var _toConsumableArray = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _require = require('factom/src/addresses'),
    isValidEcAddress = _require.isValidEcAddress,
    isValidFctAddress = _require.isValidFctAddress,
    isValidPrivateEcAddress = _require.isValidPrivateEcAddress,
    isValidPrivateFctAddress = _require.isValidPrivateFctAddress,
    isValidPublicEcAddress = _require.isValidPublicEcAddress,
    isValidPublicFctAddress = _require.isValidPublicFctAddress;

var _require2 = require('factom-identity-lib/src/app/key-helpers'),
    isValidIdentityKey = _require2.isValidIdentityKey,
    isValidPublicIdentityKey = _require2.isValidPublicIdentityKey,
    isValidSecretIdentityKey = _require2.isValidSecretIdentityKey;

var serverKey = require('factom-identity-lib/src/server/validation');

module.exports = function (joi) {
  return {
    base: joi.string(),
    name: 'factom',
    language: {
      identityKey: 'needs to be a valid {{type}} identity key',
      factoidAddress: 'needs to be a valid {{type}} factoid address',
      entryCreditAddress: 'needs to be a valid {{type}} entry credit address',
      serverIdentityKey: 'needs to be a valid {{type}} server identity key of priority [{{priority}}]'
    },
    rules: [getRule(joi, 'identityKey', isValidPublicIdentityKey, isValidSecretIdentityKey, isValidIdentityKey), getRule(joi, 'factoidAddress', isValidPublicFctAddress, isValidPrivateFctAddress, isValidFctAddress), getRule(joi, 'entryCreditAddress', isValidPublicEcAddress, isValidPrivateEcAddress, isValidEcAddress), {
      name: 'serverIdentityKey',
      params: {
        options: joi.object().keys({
          type: joi.string().valid(['public', 'private', 'secret']),
          priority: joi.number().valid([1, 2, 3, 4])
        })
      },
      validate: function validate(params, value, state, options) {
        var _ref = params.options || {},
            _ref$type = _ref.type,
            type = _ref$type === void 0 ? '' : _ref$type,
            _ref$priority = _ref.priority,
            priority = _ref$priority === void 0 ? 0 : _ref$priority;

        var validPrefixes = getValidPrefixes(type, priority);

        if (!serverKey.isValidIdentityKey(value, validPrefixes)) {
          return this.createError('factom.serverIdentityKey', {
            v: value,
            type: type,
            priority: priority || 'any'
          }, state, options);
        }

        return value;
      }
    }]
  };
};

var flatMap = function flatMap(a) {
  var _ref2;

  return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(a));
};

function getValidPrefixes(type, priority) {
  var validPrefixes = [];

  switch (type) {
    case '':
      validPrefixes.push('id', 'sk');
      break;

    case 'public':
      validPrefixes.push('id');
      break;

    case 'secret':
    case 'private':
      validPrefixes.push('sk');
  }

  switch (priority) {
    case 1:
    case 2:
    case 3:
    case 4:
      return validPrefixes.map(function (p) {
        return p + priority;
      });

    case 0:
      return flatMap(validPrefixes.map(function (p) {
        return [p + 1, p + 2, p + 3, p + 4];
      }));
  }
}

function getRule(joi, name, fnPublic, fnPrivate, fnAll) {
  return {
    name: name,
    params: {
      type: joi.any().valid(['public', 'private', 'secret'])
    },
    validate: function validate(params, value, state, options) {
      var _params$type = params.type,
          type = _params$type === void 0 ? '' : _params$type;

      switch (type) {
        case 'public':
          if (!fnPublic(value)) {
            return this.createError("factom.".concat(name), {
              v: value,
              type: type
            }, state, options);
          }

          break;

        case 'secret':
        case 'private':
          if (!fnPrivate(value)) {
            return this.createError("factom.".concat(name), {
              v: value,
              type: type
            }, state, options);
          }

          break;

        case '':
          if (!fnAll(value)) {
            return this.createError("factom.".concat(name), {
              v: value,
              type: type
            }, state, options);
          }

          break;
      }

      return value;
    }
  };
}